import React from "react";
import { EmblaOptionsType } from "embla-carousel-react";

import { HOMEPAGE_V2 } from "@config/testIds/app";

import { SERVICE_TYPE } from "@typings/globals";

import { breakpointsValuesV2 } from "@ui/themes/default";
import { MyIconProps } from "@ui/Assets/MyIcons/MyIcons";
import { mq } from "@ui/helpers";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Tabs.styled";

export const servicesTranslations: Record<SERVICE_TYPE, string> = {
  [SERVICE_TYPE.HOME_CLEANING]: "batmaid_pwa_generic.service_type_b2c",
  [SERVICE_TYPE.END_OF_TENANCY]: "batmaid_pwa_generic.service_type_eot",
  [SERVICE_TYPE.B2B]: "batmaid_pwa_generic.service_type_b2b",
};

export const servicesTestIds: Record<SERVICE_TYPE, string> = {
  [SERVICE_TYPE.HOME_CLEANING]: HOMEPAGE_V2.EXTRAS_HOME_CLEANING,
  [SERVICE_TYPE.END_OF_TENANCY]: HOMEPAGE_V2.EXTRAS_END_OF_TENANCY,
  [SERVICE_TYPE.B2B]: HOMEPAGE_V2.EXTRAS_BUSINESS_CLEANING,
};

export const tabsOrder: SERVICE_TYPE[] = [
  SERVICE_TYPE.HOME_CLEANING,
  SERVICE_TYPE.END_OF_TENANCY,
  SERVICE_TYPE.B2B,
];

export const emblaOptions: EmblaOptionsType = {
  align: "start",
  dragFree: true,
  active: true,
  breakpoints: {
    [mq([breakpointsValuesV2.smallTablet], undefined, false)]: {
      active: false,
    },
  },
};

interface Props {
  className?: string;
}

export const getItem = (
  label: string,
  Icon: React.FC<MyIconProps>,
  displayName: string,
): React.FC<Props> => {
  const Component: React.FC<Props> = props => {
    const translate = useTranslate("batmaid_pwa_static_homepage");

    return (
      <Styled.Item className={props.className}>
        <Icon />
        <Styled.ItemLabel>{translate(label)}</Styled.ItemLabel>
      </Styled.Item>
    );
  };

  Component.displayName = displayName;

  return Component;
};
